<template>
  <div id="TestDetails" class="tests-details">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <LeftNav></LeftNav>
        <b-col>
          <b-row>
            <b-col class="spaced">
              <h5 class="pointer icon-container" @click="back"><i class="material-icons">arrow_back</i> <span>back</span></h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-row class="details-wrapper spaced text-muted small">
                <b-col>{{getCountryById(test.countryId).name}}</b-col>
                <b-col>{{getCarrierById(test.carrierId).name}} ({{test.percentage}}%)</b-col>
                <b-col>{{test.breakout}}</b-col>
                <b-col class="text-center">&ndash;</b-col>
                <b-col>{{test.start | formatDate}}</b-col>
                <b-col>{{test.end | formatDate}}</b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p class="kibana-link">
                <a :href="kibanaUrl" target="_blank" class="icon-container">
                  <i class="material-icons">open_in_new</i>
                  <span>Kibana link</span>
                </a>
              </p>
              <iframe :src="kibanaIframeUrl" height="800" width="100%" frameBorder="0"></iframe>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LeftNav from '@/components/layout/LeftNav.vue'
import Header from '@/components/layout/Header.vue'

export default {
  name: 'TestDetails',
  components: {
    LeftNav,
    Header
  },
  data: () => {
    return {
      test: {},
      kibanaUrl: '',
      kibanaIframeUrl: ''
    }
  },
  async created () {
    await this.loadCountries()
    await this.loadCarriers()
  },
  mounted () {
    if ('id' in this.$route.params) {
      this.loadTests().then(() => {
        let test = this.getTestById(this.$route.params.id)
        if (test) {
          this.test = Object.assign({}, test)
          this.setIframeUrl()
        } else {
          this.$router.push({name: 'ongoingtests'})
        }
      })
    } else {
      this.$router.push({name: 'ongoingtests'})
    }
  },
  computed: {
    ...mapGetters({
      'getTestById': 'tests/getTestById',
      'getCarrierById': 'tests/getCarrierById',
      'getCountryById': 'countries/getCountryById'
    })
  },
  methods: {
    ...mapActions({
      'loadTests': 'tests/loadTests',
      'loadCarriers': 'tests/loadCarriers',
      'loadCountries': 'countries/loadCountries'
    }),
    back () {
      this.$router.go(-1)
    },
    setIframeUrl () {
      var terminatorName = this.getCarrierById(this.test.carrierId).name
      /* if (process.env.NODE_ENV === 'production') {
        this.kibanaUrl = `https://59dd70c470e7d52a671b5d22b69493df.us-east-1.aws.found.io/app/kibana#/dashboard/69019fc0-52c1-11e8-a4cd-91a952830ff4?embed=true&_g=()&_a=(description:'',filters:!(),options:(darkTheme:!f),panels:!((col:1,id:'Short-calls-per-terminator-(daily)',panelIndex:13,row:7,size_x:12,size_y:3,type:visualization),(col:1,id:'ASR-(daily)',panelIndex:26,row:4,size_x:12,size_y:3,type:visualization),(col:1,id:ACD-per-termination-provider,panelIndex:31,row:1,size_x:12,size_y:3,type:visualization),(col:1,id:'779b0020-52c2-11e8-a4cd-91a952830ff4',panelIndex:32,row:10,size_x:12,size_y:7,type:visualization),(col:1,id:'06f100a0-52c6-11e8-a4cd-91a952830ff4',panelIndex:33,row:17,size_x:12,size_y:14,type:visualization),(col:1,id:fed7df90-52c7-11e8-a4cd-91a952830ff4,panelIndex:34,row:31,size_x:12,size_y:3,type:visualization),(col:1,id:'119abad0-52c8-11e8-a4cd-91a952830ff4',panelIndex:35,row:34,size_x:12,size_y:3,type:visualization)),query:(match_all:()),timeRestore:!f,title:'Routing+Tool+Dashboard',uiState:(P-13:(vis:(legendOpen:!f)),P-32:(vis:(params:(sort:(columnIndex:!n,direction:!n)))),P-33:(vis:(params:(sort:(columnIndex:!n,direction:!n))))),viewMode:view)`
      } else {
        /* old one
        this.kibanaUrl = `https://59dd70c470e7d52a671b5d22b69493df.us-east-1.aws.found.io/app/kibana#/dashboard/b1312bb0-5750-11e8-a4cd-91a952830ff4?embed=true&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:now-14d%2Fd,mode:relative,to:now))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:DestinationCountry.keyword,negate:!f,type:phrase,value:${this.test.countryId}),query:(match:(DestinationCountry.keyword:(query:${this.test.countryId},type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:Destination.keyword,negate:!f,type:phrase,value:'${this.test.breakout}'),query:(match:(Destination.keyword:(query:'${this.test.breakout}',type:phrase))))),options:(darkTheme:!f),panels:!((col:1,id:Daily-percent-Duration-per-Terminator,panelIndex:1,row:1,size_x:6,size_y:3,type:visualization)),query:(match_all:()),timeRestore:!t,title:'Routing+test+tool+-+Current+setup',uiState:(P-1:(vis:(legendOpen:!f))),viewMode:view)`
        */
      // production
      this.kibanaUrl = `https://0e515e669932436ea8d7fc647181e7a0.us-east-1.aws.found.io:9243/app/kibana#/dashboard/69019fc0-52c1-11e8-a4cd-91a952830ff4?_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${this.test.start}',mode:absolute,to:'${this.test.end}'))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:DestinationCountry.keyword,negate:!f,type:phrase,value:${this.test.countryId}),query:(match:(DestinationCountry.keyword:(query:${this.test.countryId},type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:Destination,negate:!f,type:phrase,value:'${this.test.breakout}'),query:(match:(Destination:(query:'${this.test.breakout}',type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!t,index:'cdr_*',key:Terminator,negate:!f,type:phrase,value:'${terminatorName}'),query:(match:(Terminator:(query:'${terminatorName}',type:phrase))))))`
      this.kibanaIframeUrl = this.kibanaUrl + '&embed=true'
      // }
    },
    save () {
      alert('not implemented')
    }
  }
}
</script>
<style lang="scss" scoped>
$border-color: #ddd;
.details-wrapper {
  padding-top: 15px;
  padding-bottom: 15px;
  border: 1px solid $border-color;
  border-radius: 5px;
  &.spaced{
    margin-top: 0px;
  }
}
.spaced {
  margin: 20px;
}
.kibana-link{
  margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/tests/TestDetails.vue